import { Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import QuickForm from "../../Components/Forms/QuickForm/QuickForm"
import { convertActiveQueryToUrl } from "../../Helpers/Query/queryHelpers";
import useActiveQueryHook from "../../Hooks/UseActiveQuery/useActiveQueryHook";
import { BuildingEntryType } from "../../Types/buildingTypes"
import BuildingEntry from "../../Components/Buildings/BuildingEntry"
import { useGetBuildingsQuery } from "../../services/bClientApi"
import MongoPagination from "../../Components/Pagination/MongoPagination"

export default function BuildingsPage() {

    const dispatch = useAppDispatch()

    const { activeQuery } = useActiveQueryHook({
            query: {},
            limit: 10,
    })

    const {
        data,
        isLoading,
        error,
    } = useGetBuildingsQuery({
        buildingsQuery: activeQuery.query,
        pagination: {
            page: activeQuery.page,
            limit: activeQuery.limit
        }
    })

    const buildingsList = data?.docs || []

    const loadPage = (pageParams: { query: any, page: number, limit: number }) => {
        const destination = `/buildings?${convertActiveQueryToUrl(pageParams)}`
        dispatch(navigateTo(destination))
    }


    return (
        <Container>
            <Row>
                <Col>
                    <h1>Buildings</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <QuickForm
                        initialData={{
                            name: activeQuery.query.name,
                        }}
                        fields={[
                            {
                                fieldName: 'title',
                                fieldLabel: 'Title',
                                fieldType: 'text',
                                placeholder: 'Title',
                            }
                        ]}
                        disabled={isLoading}
                        onSubmit={(values: any) => {
                            loadPage({
                                query: values,
                                page: 1,
                                limit: activeQuery.limit
                            })
                        }}
                    />

                    <div className="building-list-container">
                        {buildingsList && buildingsList.length > 0 && buildingsList.map((buildingEntry: BuildingEntryType, idx: number) => (
                            <BuildingEntry
                                key={idx}
                                buildingInfo={buildingEntry}
                            />
                        ))
                        }
                    </div>

                        <MongoPagination
                            data={data}
                            loadPage={(pageLoadInfo: { page: number, limit?: number }) => {
                                loadPage({
                                    query: activeQuery.query,
                                    limit: activeQuery.limit,
                                    ...pageLoadInfo
                                })
                            }}
                        />
                </Col>
            </Row>
        </Container>
    )
}
